<template>
  <div id="aw-fw">
    <h3 v-if="showHead">Full Video</h3>
    <div class="rnd-crns">
      <VideoPlayer
        v-if="!fullvideo.iframe_url || fullvideo.iframe_url == ''"
        :video_urls="fullvideo"
        :duration="duration"
        :subtitleUrls="subtitleUrls"
        :subtitles="subtitles"
        :videoType="VideoType.Webinar"
      />
      <IframeVideoPlayer
        v-else
        :iframe_url="fullvideo.iframe_url"
        :poster="fullvideo.poster_url"
        :duration="duration"
      />
    </div>
  </div>
</template>
<script lang="ts">
import "@/assets/fullVideoComponent.css"
import { VideoInfo } from "@/models/VideoInfo"
import VideoPlayer from "@/components/shared/Player.vue"
import IframeVideoPlayer from "@/components/shared/IframeVideoPlayer.vue"
import { SubtitleUrls } from "@/models/captions/SubtitleUrls"
import { defineComponent, PropType } from "vue"
import { VideoType } from "@/models/VideoType"

export default defineComponent({
  components: { VideoPlayer, IframeVideoPlayer },
  props: {
    fullvideo: Object as PropType<VideoInfo>,
    showHead: Boolean,
    duration: String,
    subtitleUrls: Object as PropType<SubtitleUrls>,
    subtitles: Array as PropType<Array<SubtitleUrls>>
  },
  setup() {
    return { VideoType }
  }
})
</script>
